import { render, staticRenderFns } from "./resupply-products.modal.vue?vue&type=template&id=c2824f54&scoped=true&"
import script from "./resupply-products.modal.vue?vue&type=script&lang=js&"
export * from "./resupply-products.modal.vue?vue&type=script&lang=js&"
import style0 from "./resupply-products.modal.vue?vue&type=style&index=0&id=c2824f54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2824f54",
  null
  
)

export default component.exports